module.exports = __webpack_public_path__ + "img/seller-01.0823e2dd.png";